import FundsAndDocuments from './FundsAndDocuments'

export default FundsAndDocuments
